export default "\n{% block sw_first_run_wizard_paypal_credentials %}\n<div>\n    {# should be overwritten by plugin #}\n</div>\n{% endblock %}\n";